<template>
  <div class="position-relative h-100 mh-100 overflow-hidden">
    <job-template-form
      v-if="!fetchingEmptyJobTemplate && !fetchingOutputGroupOptions"
      :from-jobs="fromJobs"
      :from-live-jobs="fromLiveJobs"
      :submit-loading="creatingJobTemplate"
      @submit="createJobTemplate"
    />
    <loading-page v-else />
  </div>
</template>

<script>
import JobTemplateForm from './JobTemplateForm.vue'
import redirectError from '@/services/redirectError'

export default {
  name: 'CreateJobTemplate',
  components: { JobTemplateForm },
  data() {
    return {
      fromJobs: false,
      fromLiveJobs: false,
    }
  },
  computed: {
    fetchingEmptyJobTemplate() {
      return this.$store.state.jobTemplates.fetchingEmptyJobTemplate
    },
    fetchingOutputGroupOptions() {
      return this.$store.state.jobTemplates.fetchingOutputGroupOptions
    },
    creatingJobTemplate() {
      return this.$store.state.jobTemplates.creatingJobTemplate
    },
    creatingOutputPreset() {
      return this.$store.state.jobTemplates.creatingOutputPreset
    },
  },
  created() {
    if (this.$route.query.from === 'jobs') {
      this.fromJobs = true
    }
    if (this.$route.query.from === 'live-jobs') {
      this.fromLiveJobs = true
    }
    if (
      !this.$route.params.backFromOutputPresets
      || !this.creatingOutputPreset
    ) {
      this.init()
    }
    this.$store.commit('jobTemplates/SET_CREATING_OUTPUT_PRESET', false)
  },
  methods: {
    init() {
      this.fetchEmptyJobTemplate()
      this.fetchOutputGroupOptions()
      this.$store.commit('jobTemplates/SET_OUTPUT_TABS', [])
    },
    fetchEmptyJobTemplate() {
      this.$store
        .dispatch('jobTemplates/fetchEmptyJobTemplate')
        .catch(err => redirectError(err, this.$router, this.$route.path))
    },
    fetchOutputGroupOptions() {
      this.$store
        .dispatch('jobTemplates/fetchOutputGroupOptions')
        .catch(err => redirectError(err, this.$router, this.$route.path))
    },
    createJobTemplate(obj) {
      this.$store
        .dispatch('jobTemplates/createJobTemplate', obj)
        .then(() => {
          this.$router.push({
            // eslint-disable-next-line no-nested-ternary
            name: this.fromJobs
              ? 'jobs-create'
              : this.fromLiveJobs
                ? 'create-live-encoder'
                : 'job-templates',
            params: {
              projectId: this.$route.params.projectId,
              toast: {
                title: 'Success',
                variant: 'success',
                message: 'Job template created successfully!',
              },
              backFromJobTemplate: true,
            },
          })
        })
        .catch(() => {
          this.errorToast('An error occurred')
        })
    },
  },
}
</script>

<style></style>
